var $63cf4a75ec270508$exports = {};
$63cf4a75ec270508$exports = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};


export {$63cf4a75ec270508$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
